var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightShare = function SvgRightShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M418.06 301.94c-17.55 17.55-17.55 45.9 0 63.45l174.6 174.6-174.6 174.6c-17.55 17.55-17.55 45.9 0 63.45 17.55 17.55 45.9 17.55 63.45 0l206.55-206.55c17.55-17.55 17.55-45.9 0-63.45L481.51 301.49c-17.1-17.1-45.9-17.1-63.45.45Z"
  })));
};
export default SvgRightShare;